function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Homepage",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home---3-",
  transform: "translate(-476.000000, -558.000000)",
  fill: "#BEC7D2",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Info_2510063",
  transform: "translate(476.000000, 558.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.7418356,4.16902667 C12.5964984,4.71141613 12.0389872,5.03329192 11.4965969,4.88795786 C10.9542066,4.7426238 10.6323276,4.18511448 10.7776585,3.64272333 C10.9229894,3.10033219 11.4804969,2.77844997 12.0228889,2.92377778 C12.2833597,2.99356616 12.505438,3.16396973 12.6402673,3.39750029 C12.7750965,3.63103085 12.8116319,3.90855799 12.7418356,4.16902667 L12.7418356,4.16902667 Z M11.4304067,14.4023156 L11.4206289,14.4086378 C10.7408511,14.8565533 9.74817111,15.3415667 10.0871733,14.0763889 L11.8993956,7.31304222 C12.1955556,6.20781778 10.5365933,6.02644444 9.43311111,6.59822222 C8.62588164,7.01453652 7.91179876,7.59074272 7.33431556,8.29177778 C7.18829026,8.46215538 7.18632896,8.71297909 7.32967205,8.88561939 C7.47301514,9.05825969 7.71992377,9.10244692 7.91424444,8.99023556 L7.92399556,8.98392889 C8.60379111,8.53601333 9.59646667,8.05098667 9.25746444,9.31617778 L7.44524222,16.0795111 C7.14911111,17.1847333 8.80806444,17.3660889 9.91154,16.7943511 C10.7187678,16.3780314 11.4328465,15.8018181 12.0103222,15.1007756 C12.1563519,14.9304017 12.158318,14.6795775 12.0149771,14.5069353 C11.8716362,14.3342932 11.6247274,14.2901042 11.4304067,14.4023156 L11.4304067,14.4023156 Z M20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 C12.6521649,0 15.195704,1.0535684 17.0710678,2.92893219 C18.9464316,4.80429597 20,7.3478351 20,10 Z M18.8888889,10 C18.8888889,5.09080222 14.9091978,1.11111111 10,1.11111111 C5.09080222,1.11111111 1.11111111,5.09080222 1.11111111,10 C1.11111111,14.9091978 5.09080222,18.8888889 10,18.8888889 C14.906899,18.8833437 18.8833437,14.906899 18.8888889,10 Z",
  id: "Shape"
}))));
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8c93c2ab7e0d31ea873575f45e17b813.svg";
export { ForwardRef as ReactComponent };